<template>
  <div>
    <div class="main-title">安全员列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add()">添加安全员</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索安全员姓名/身份证/手机号"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:250px;"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="companyname"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="100">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          width="80">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="driver_license"
          label="驾驶证号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="license_date"
          label="驾驶证领证日期"
          width="130">
        </el-table-column>
        <el-table-column
          prop="status"
          label="在职状态"
          >
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="update(scope.row)">修改</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 教练信息修改窗口 -->
    <el-dialog :title="form.id > 0 ? '修改安全员信息' : '添加安全员'" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item prop="name" label="姓名">
          <el-input v-model="form.name" style="width:194px;" :disabled="form.id > 0"></el-input>
        </el-form-item>
        <el-form-item prop="company_id" label="所属科目">
          <el-select
              v-model="form.company_id"
              placeholder="选择科目"
              style="width:194px;"
              :disabled="form.id > 0">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="sex" label="性别">
          <el-select v-model="form.sex" style="width:194px;">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.idcard" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="驾驶证号">
          <el-input v-model="form.driver_license" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="驾驶证初领日期">
          <el-date-picker style="width:194px;"
            v-model="form.license_date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择" style="width:194px;">
            <el-option label="在职" value="在职"></el-option>
            <el-option label="离职" value="离职"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comit" :loading="comiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'secu_list',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        daterange: []
      },
      form: {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        company_id: null,
        driver_license: null,
        license_date: null,
        status: '在职'
      },
      formVisible: false,
      comiting: false,
      companyList: [],
      formRules: {
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        sex: [
          { required: true, message: "选择性别", trigger: "blur" }
        ],
        company_id: [
          { required: true, message: "选择所属科目", trigger: "blur" }
        ]
      }
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.status === '离职') {
        return 'row-red';
      }
      return '';
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
        }
      })
    },
    add () {
      this.form = {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        company_id: null,
        driver_license: null,
        license_date: null,
        status: '在职'
      }
      this.formVisible = true
    },
    update (row) {
      this.form = {
        id: row.id,
        name: row.name,
        sex: row.sex,
        phone: row.phone,
        idcard: row.idcard,
        company_id: row.company_id,
        driver_license: row.driver_license,
        license_date: row.license_date,
        status: row.status
      }
      this.formVisible = true
    },
    comit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.commiting = true
          let url = '/dbapi/update_secu'
          if (this.form.id === 0) {
            url = '/dbapi/insert_secu'
          }
          this.form.name_pinyin = this.form.name_py = this.form.name
          this.$http.post(url, this.form).then(response => {
            this.commiting = false
            if (response.data.success) {
              this.formVisible = false
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.refresh()
              if (this.$route.path.endsWith('new')) {
                this.$router.go(-1)
              }
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_secu', { id: row.id }).then(response => {
          if (response.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/data/Secu.vue